import { CaretRightOutlined } from '@ant-design/icons';
import { Button, Col, Collapse, Form, Input, Radio, Row, message, theme } from 'antd';
import React, { useEffect, useState } from 'react';
import { format, validate } from 'rut.js';
import { useFormContext } from '../../Context/DeclarationContext';
import RutTools from '../../helpers/format-rut';
import FormInputPhone2 from '../Inputs/Form_Input_Phone/form_input_phone2';

const { Panel } = Collapse;
interface FormColapseProps {
  indicador: number;
  thirdPartyInvolvedInformation: any;
  setThirdPartyInvolvedInformation?: any;
  setIndicadorDeleted?: any;
}
const FormColapse = ({ indicador, thirdPartyInvolvedInformation, setThirdPartyInvolvedInformation, setIndicadorDeleted }: FormColapseProps) => {
  const { token } = theme.useToken();
  const { state, dispatch } = useFormContext();
  const [optionRadioValue, setOptionRadioValue] = useState<string>('VEHICLE');
  const [element_form_vehicle] = Form.useForm();
  const [element_form_person] = Form.useForm();
  const [formDisabledVehicle, setFormDisabledVehicle] = useState<boolean>(false);
  const [formDisabledPerson, setFormDisabledPerson] = useState<boolean>(false);
  const [radioDisabled, setRadioDisabled] = useState<boolean>(false);
  const [validateMessage, setValidateMessage] = useState<boolean>(false);
  const panelStyle: React.CSSProperties = {
    marginBottom: 24,
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: '1px solid #E9E9E9',
    width: '97%',
    marginTop: '25px',
  };

  const onChangeRadio = (e: any) => {
    setOptionRadioValue(e.target.value);
  };

  useEffect(() => {
    if (state?.thirdPartyInvolved?.thirdPartyInvolvedInformation?.length) {
      if (state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.damageType === 'VEHICLE') {
        setFormDisabledVehicle(true);
        setFormDisabledPerson(true);
        setRadioDisabled(true);
        onChangeRadio({ target: { value: 'VEHICLE' } });
        setOptionRadioValue('VEHICLE');

        const nPhone = state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyVehicleInformation?.phoneNumber;
        element_form_vehicle.setFieldsValue({
          damageDescription: state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyVehicleInformation?.damageDescription,
          vehiclePlate: state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyVehicleInformation?.vehiclePlate,
          identityNumber: state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyVehicleInformation?.identityNumber,
          thirdPartyFullName: state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyVehicleInformation?.thirdPartyFullName,
          phoneNumber: nPhone ? nPhone : { phone_code: '+56', stringValue: '' },
          email: state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyVehicleInformation?.email,
          hasInsurance: state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyVehicleInformation?.hasInsurance,
          alcoholTestConducted:
            state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyVehicleInformation?.alcoholTestConducted,
        });
      }

      if (state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.damageType === 'PERSON_OR_PROPERTY') {
        setFormDisabledVehicle(true);
        setFormDisabledPerson(true);
        setRadioDisabled(true);
        onChangeRadio({ target: { value: 'PERSON_OR_PROPERTY' } });
        setOptionRadioValue('PERSON_OR_PROPERTY');

        const phnContact = state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyPersonOrPropertyInformation?.phoneContact;
        element_form_person.setFieldsValue({
          damageDescription:
            state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyPersonOrPropertyInformation?.damageDescription,
          damageDetail: state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyPersonOrPropertyInformation?.damageDetail,
          contactName: state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyPersonOrPropertyInformation?.contactName,
          phoneContact: phnContact ? phnContact : { phone_code: '+56', stringValue: '' },
          additionalNotes:
            state?.thirdPartyInvolved?.thirdPartyInvolvedInformation[indicador]?.thirdPartyPersonOrPropertyInformation?.additionalNotes,
        });
      }
    }
  }, []);

  const validatePhoneNumber = (rule: any, value: string, callback: Function) => {
    const phoneNumberRegex = /^\+56\s9\s\d{4}\s\d{4}$/;
    if (value === '') {
      callback();
    } else if (phoneNumberRegex.test(value)) {
      callback();
    } else {
      callback('¡Por favor, introduce un número de teléfono válido!');
    }
  };
  const onFinishVehicle = (values: any) => {
    const cleanedValues = removeEmptyValues({
      ...values,
      identityNumber: RutTools.formatWithoutDots(values?.identityNumber),
    });
    if (thirdPartyInvolvedInformation.length > 0) {
      thirdPartyInvolvedInformation = thirdPartyInvolvedInformation.map((item: any) => {
        if (item.indicador === indicador) {
          return {
            ...item,
            thirdPartyVehicleInformation: {
              ...cleanedValues,
            },
          };
        } else {
          setThirdPartyInvolvedInformation([
            ...thirdPartyInvolvedInformation,
            {
              indicador: indicador,
              damageType: optionRadioValue,
              thirdPartyPersonOrPropertyInformation: null,
              thirdPartyVehicleInformation: {
                ...cleanedValues,
              },
            },
          ]);
        }
      });
    } else {
      setThirdPartyInvolvedInformation([
        ...thirdPartyInvolvedInformation,
        {
          indicador: indicador,
          damageType: optionRadioValue,
          thirdPartyPersonOrPropertyInformation: null,
          thirdPartyVehicleInformation: {
            ...cleanedValues,
          },
        },
      ]);
    }

    setFormDisabledVehicle(true);
    setRadioDisabled(true);
    message.success('¡Datos guardados correctamente!');
  };
  const removeEmptyValues = (obj: Record<string, any>): Record<string, any> => {
    const newObj: Record<string, any> = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== '') {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  };

  const onFinishPerson = (values: any) => {
    if (thirdPartyInvolvedInformation.length > 0) {
      thirdPartyInvolvedInformation = thirdPartyInvolvedInformation.map((item: any) => {
        const cleanedValues = removeEmptyValues(values);
        if (item.indicador === indicador) {
          return {
            ...item,
            thirdPartyPersonOrPropertyInformation: {
              ...cleanedValues,
            },
          };
        } else {
          setThirdPartyInvolvedInformation([
            ...thirdPartyInvolvedInformation,
            {
              indicador: indicador,
              damageType: optionRadioValue,
              thirdPartyPersonOrPropertyInformation: {
                ...cleanedValues,
              },
              thirdPartyVehicleInformation: null,
            },
          ]);
        }
      });
    } else {
      setThirdPartyInvolvedInformation([
        ...thirdPartyInvolvedInformation,
        {
          indicador: indicador,
          damageType: optionRadioValue,
          thirdPartyPersonOrPropertyInformation: {
            ...values,
          },
          thirdPartyVehicleInformation: null,
        },
      ]);
    }

    setFormDisabledPerson(true);
    setRadioDisabled(true);
    message.success('¡Datos guardados correctamente!');
  };

  const [valueSearchInput, setValueSearchInput] = useState('');

  return (
    <Collapse
      defaultActiveKey={['1']}
      bordered={false}
      expandIconPosition="right"
      collapsible="icon"
      expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
      style={{ background: token.colorBgContainer }}
    >
      <Panel
        header={
          <Radio.Group
            onChange={(e) => {
              onChangeRadio(e);
            }}
            value={optionRadioValue}
            disabled={radioDisabled}
          >
            <Radio value={'VEHICLE'}>Daño vehículo de tercero</Radio>
            <Radio value={'PERSON_OR_PROPERTY'}>Otros bienes y/o personas</Radio>
          </Radio.Group>
        }
        key="1"
        style={panelStyle}
      >
        {optionRadioValue === 'VEHICLE' && (
          <Form
            form={element_form_vehicle}
            name="dynamic_form_nest_item1"
            onFinish={onFinishVehicle}
            autoComplete="off"
            disabled={formDisabledVehicle}
          >
            <Row gutter={[24, 8]}>
              <Col sm={24} xs={24}>
                <Form.Item
                  label="Detalle del daño"
                  name="damageDescription"
                  extra={validateMessage ? 'La cantidad máxima es de 500 caracteres' : null}
                  required
                  rules={[
                    {
                      required: true,
                      message: '¡Por favor, introduce el detalle del daño!',
                    },
                    {
                      validator: async (_, value) => {
                        if (value?.length > 500) {
                          setValidateMessage(false);
                          return Promise.reject('La cantidad máxima es de 500 caracteres');
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input.TextArea rows={4} maxLength={500} placeholder="Ingrese el detalle de todos los daños" />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Patente del tercero"
                  name="vehiclePlate"
                  rules={[
                    {
                      pattern: /^[a-zA-Z0-9]{5,6}$/,
                      message: '¡Por favor, introduce una patente válida!',
                    },
                  ]}
                >
                  <Input
                    onChange={(e) => {
                      element_form_vehicle.setFieldValue('vehiclePlate', e?.target?.value?.toUpperCase());
                    }}
                    placeholder="Ej: RFBH58"
                  />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Rut del tercero"
                  name="identityNumber"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (value?.length === 0 || value?.length === undefined) {
                          return Promise.resolve();
                        } else if (validate(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('El rut ingresado es inválido.*'));
                      },
                    },
                  ]}
                  normalize={(value) => {
                    if (value === '-') {
                      return '';
                    } else {
                      return format(value);
                    }
                  }}
                >
                  <Input placeholder={'Ejemplo: 11111111-1'} />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Nombre completo del tercero"
                  name="thirdPartyFullName"
                  rules={[
                    {
                      pattern: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s0-9.-_]+$/,
                      message: 'Los nombres no pueden incluir caracteres especiales',
                    },
                    {
                      max: 50,
                      message: 'Debe tener máximo 50 caracteres',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <FormInputPhone2 prevalue={{ phone_code: '+56', stringValue: '' }} label="Teléfono del tercero" name="phoneNumber" required={false} />
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Correo electrónico del tercero"
                  name="email"
                  rules={[
                    {
                      type: 'email',
                      message: '¡Por favor, introduce un correo electrónico válido!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item label="¿Tiene seguro el tercero?" name="hasInsurance">
                  <Radio.Group>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item label="¿Alcoholemia del tercero?" name="alcoholTestConducted">
                  <Radio.Group>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16} justify={'center'}>
              <Button type="primary" htmlType="submit" className="btnSave">
                Guardar
              </Button>
            </Row>
          </Form>
        )}

        {optionRadioValue === 'PERSON_OR_PROPERTY' && (
          <Form form={element_form_person} name="dynamic_form_nest_item2" autoComplete="off" onFinish={onFinishPerson} disabled={formDisabledPerson}>
            <Row gutter={[24, 8]}>
              <Col sm={24} xs={24}>
                <Form.Item
                  label="Detalle del daño"
                  name="damageDescription"
                  extra={'La cantidad máxima es de 500 caracteres'}
                  rules={[
                    {
                      required: true,
                      message: '¡Por favor, introduce el detalle del daño!',
                    },
                    {
                      max: 500,
                      message: 'Debe tener máximo 500 caracteres',
                    },
                  ]}
                >
                  <Input.TextArea rows={4} maxLength={500} placeholder="Ingrese el detalle de todos los daños" />
                </Form.Item>
              </Col>
              <Col sm={24} xs={24}>
                <Form.Item
                  label="Tipo de bien y/o lesión física"
                  name="damageDetail"
                  extra={'La cantidad máxima es de 500 caracteres'}
                  rules={[
                    {
                      required: true,
                      message: '¡Por favor, introduce el detalle del daño!',
                    },
                    {
                      max: 500,
                      message: 'Debe tener máximo 500 caracteres',
                    },
                  ]}
                >
                  <Input.TextArea rows={4} maxLength={500} placeholder="Ingrese el detalle de los bienes y/o las lesiones físicas" />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Nombre de contacto"
                  name="contactName"
                  rules={[
                    {
                      pattern: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s0-9.-_]+$/,
                      message: 'Los nombres no pueden incluir caracteres especiales',
                    },
                    {
                      max: 50,
                      message: 'Debe tener máximo 50 caracteres',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col sm={8} xs={24}>
                <FormInputPhone2
                  prevalue={{ phone_code: '+56', stringValue: '' }}
                  label="Teléfono de contacto"
                  name="phoneContact"
                  required={false}
                />
              </Col>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Otro dato"
                  name="additionalNotes"
                  rules={[
                    {
                      pattern: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s0-9.-_]+$/,
                      message: 'Los nombres no pueden incluir caracteres especiales',
                    },
                    {
                      max: 50,
                      message: 'Debe tener máximo 50 caracteres',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row justify={'center'}>
              <Button type="primary" htmlType="submit" className="btnSave">
                Guardar
              </Button>
            </Row>
          </Form>
        )}
      </Panel>
    </Collapse>
  );
};

export default FormColapse;
